var _style, _path, _g, _path2, _circle, _circle2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgpad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 898.1 1289.8",
    style: {
      enableBackground: "new 0 0 898.1 1289.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#898989;stroke-miterlimit:10;}\n\t.st1{fill:#D7D7D7;}\n\t.st2{fill:none;stroke:#D7D7D7;stroke-width:2.126;stroke-miterlimit:10;}\n\t.st3{fill:#878787;}\n\t.st4{fill:#F5F5F5;stroke:#898989;stroke-width:0.5213;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M843.3,1266.7H54.8c-26.6,0-48.3-21.6-48.3-48.3V83.9c0-26.6,21.6-48.3,48.3-48.3h788.5 c26.6,0,48.3,21.6,48.3,48.3v1134.5C891.6,1245.1,870,1266.7,843.3,1266.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M448.1,1241.7c-19.1,0-34.6-15.6-34.6-34.6c0-19.1,15.6-34.6,34.6-34.6c19.1,0,34.6,15.6,34.6,34.6 C482.7,1226.2,467.3,1241.7,448.1,1241.7z M448.1,1179.5c-15.2,0-27.6,12.3-27.6,27.6c0,15.3,12.3,27.6,27.6,27.6 c15.3,0,27.6-12.3,27.6-27.6C475.8,1191.8,463.4,1179.5,448.1,1179.5z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M453.3,1217.6h-10.4c-2.9,0-5.3-2.4-5.3-5.3v-10.4c0-2.9,2.4-5.3,5.3-5.3h10.4c2.9,0,5.3,2.4,5.3,5.3v10.4 C458.6,1215.2,456.2,1217.6,453.3,1217.6z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 458.6,
    cy: 75.7,
    r: 7.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 436.1,
    cy: 75.2,
    r: 4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 64.1,
    y: 120.8,
    className: "st4",
    width: 768,
    height: 1024
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgpad);
export default __webpack_public_path__ + "static/media/bgpad.0ffa4980330deb40fd2f6e4c28bce8ce.svg";
export { ForwardRef as ReactComponent };